import { render, staticRenderFns } from "./openBill2.vue?vue&type=template&id=60c22614&scoped=true&"
import script from "./openBill2.vue?vue&type=script&lang=js&"
export * from "./openBill2.vue?vue&type=script&lang=js&"
import style0 from "./openBill2.vue?vue&type=style&index=0&id=60c22614&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c22614",
  null
  
)

export default component.exports